/* Dream Girl Studio — homepage polish
   Topp Level Marketing.

   Mobile autoplay safety net. The sewing video already has every attribute
   phones need (muted, playsinline, autoplay, loop) and the file is H.264, but
   some phones still refuse on first load — iPhone Low Power Mode, data-saver
   modes, and in-app browsers like Instagram's. This nudges any muted autoplay
   video to start once it scrolls into view, and again on the first tap or
   scroll. It never unmutes anything. */

(function () {
  'use strict';

  if (window.__tlmSiteReady) return;
  window.__tlmSiteReady = true;

  function candidates() {
    return Array.prototype.slice.call(document.querySelectorAll('video[autoplay]'))
      .filter(function (v) { return v.muted || v.hasAttribute('muted'); });
  }

  function nudge(v) {
    if (!v || !v.paused) return;
    v.muted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function nudgeAll() { candidates().forEach(nudge); }

  function watch() {
    var vids = candidates();
    if (!vids.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) nudge(e.target); });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      nudgeAll();
    }

    var events = ['touchstart', 'click', 'scroll', 'keydown'];
    var once = function () {
      nudgeAll();
      events.forEach(function (ev) { window.removeEventListener(ev, once, true); });
    };
    events.forEach(function (ev) { window.addEventListener(ev, once, { capture: true, passive: true }); });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) nudgeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/* Homepage workshop list: show the next 8 dates, then a "View all workshop
   dates" button to the full calendar, so the homepage isn't one long scroll.
   Homepage calendar section only. The Book a Workshop page still lists every
   date. Past dates drop off on their own, so this always shows the next 8. */

(function () {
  'use strict';

  var LIMIT = 8;
  var MORE_URL = '/pages/dream-girl-open-studio';
  var SECTION = '#shopify-section-template--22269206921389__17401965811a8a864e';

  function limit() {
    var cal = document.querySelector(SECTION + ' .the-shop-calendar');
    if (!cal) return;

    var cards = cal.querySelectorAll('.tscListCard');
    if (cards.length <= LIMIT) return;

    for (var i = LIMIT; i < cards.length; i++) {
      if (!cards[i].classList.contains('tlm-cal-hidden')) cards[i].classList.add('tlm-cal-hidden');
    }

    var months = cal.querySelectorAll('.tscCalendarContainer');
    for (var m = 0; m < months.length; m++) {
      var empty = !months[m].querySelector('.tscListCard:not(.tlm-cal-hidden)');
      if (empty !== months[m].classList.contains('tlm-cal-hidden')) months[m].classList.toggle('tlm-cal-hidden', empty);
    }

    if (cal.querySelector('.tlm-cal-more')) return;
    var wrap = document.createElement('div');
    wrap.className = 'tlm-cal-more';
    var a = document.createElement('a');
    a.className = 'tlm-cal-more__btn';
    a.href = MORE_URL;
    a.textContent = 'View all workshop dates';
    wrap.appendChild(a);
    cal.appendChild(wrap);
  }

  /* The calendar app can fill in or redraw its list after the page loads,
     so re-apply whenever the section changes (for the first 20 seconds). */
  function start() {
    limit();
    var host = document.querySelector(SECTION);
    if (!host || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(limit);
    mo.observe(host, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', limit);
})();
